import React from 'react';
import logo from './logo.svg';
import './App.css';
import Player from './Player';
import { instruments, midiFiles } from './data';
import Introduction from './Introduction';
import { line, intersectionSpace } from './layout';
import { Link } from 'react-router-dom';

const Home = () => (
	<>
		<div style={{ display: 'flex', flexDirection: 'column', padding: '24px' }}>
			<h1>The control-synthesis approach for making expressive and controllable neural music synthesizers</h1>
			<hr style={{ border: '2px solid black', width: '100%' }}></hr>
			<Introduction></Introduction>
			<div
				style={{
					margin: 'auto',

					display: 'flex',
					justifyContent: 'space-evenly',
					alignItems: 'start',
					flexDirection: 'column',

					fontSize: 24,
				}}
			>
				<h2>Links:</h2>
				<Link style={{ marginTop: 24 }} to="/evaluation">
					➤ Audio examples
				</Link>
				<Link style={{ marginTop: 24 }} to="/plots">
					➤ Plots of control model predictions
				</Link>
				<Link style={{ marginTop: 24 }} to="/controlflexibility">
					➤ Additional experiments concerning control flexibility
				</Link>
				<a style={{ marginTop: 24 }} href="https://github.com/erl-j/control-synthesis">
					➤ Code on github
				</a>
			</div>
		</div>
		<div
			style={{
				margin: 'auto',
				display: 'flex',
				flexDirection: 'column',
				padding: '16px',
				justifyContent: 'center',
			}}
		>
			{instruments.map((ins) => (
				<React.Fragment key={ins.id}>
					<h2>{ins.displayName}</h2>
					{line}
					<hr></hr>

					<Player
						title={'Training data excerpt'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/${ins.id}/` + 'target.wav'}
					></Player>
					{midiFiles.map(
						(mf) =>
							!mf.hide && (
								<div style={{ marginTop: 10, marginBottom: 20 }} key={mf.displayName}>
									<Player
										title={mf.displayName}
										midiFilePath={process.env.PUBLIC_URL + '/midi/' + mf.fileName}
										audioFilePath={
											mf.audioFileName
												? process.env.PUBLIC_URL + `/audio/${ins.id}/` + mf.audioFileName
												: process.env.PUBLIC_URL +
												  `/audio/${ins.id}/` +
												  mf.fileName +
												  '_generated_performance.wav'
										}
									></Player>
								</div>
							)
					)}
					{intersectionSpace}
				</React.Fragment>
			))}
		</div>
	</>
);

export default Home;
